<template>
	<div class="text-justify">
		<div class="row">
			<div class="col-lg-12">
				<lead-profile-tab-log-table :value=value></lead-profile-tab-log-table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "LeadTabLog",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			log: {},
		};
	},
};
</script>

<style scoped>
.ml-20 {
	margin-left: 20px; /* You can adjust the margin value as needed */
}
.mr-20 {
	margin-right: 20px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 20px;
}
</style>
